export default __webpack_public_path__ + "static/tesco.url-894f477c52786313b7c647d7e63d14f3.svg";